module.exports = __webpack_public_path__ + "media/question3_au.c119fd36.mp3";